import { render, staticRenderFns } from "./ReturnArticleFromDocument.vue?vue&type=template&id=0d9da76f&scoped=true"
import script from "./ReturnArticleFromDocument.vue?vue&type=script&lang=js"
export * from "./ReturnArticleFromDocument.vue?vue&type=script&lang=js"
import style0 from "./ReturnArticleFromDocument.vue?vue&type=style&index=0&id=0d9da76f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9da76f",
  null
  
)

export default component.exports